import { RestUrl } from "../common/cyan.types";

export class BuilderOrganizationUrl {
  public static paginateBuilderMyOrganizations: RestUrl = ["GET", "/organizations/my"];
}
